export default ({ $config }, inject) => {
  inject('cdnImg', (path) => `${$config.cdnBase}${path}`);
};
